import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

// Developers: an app without declared category + compatibility is not published; red alert with a button to the form.
export const IncompleteAlert = ({ to, count, testId }) => {
  const { t } = useI18n();
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-3 rounded-xl border border-red-500/70 bg-red-950/70 p-3 text-sm font-semibold text-red-100" role="alert" data-testid={testId}>
      <AlertTriangle className="h-5 w-5 shrink-0 text-red-300" />
      <span className="min-w-0 flex-1 basis-48 break-words">{count ? t("plat.incompleteMany", { n: count }) : t("plat.incomplete")}</span>
      {to && <Link to={to} className="btn-red btn-sm max-w-full whitespace-normal" data-testid={`${testId}-btn`}>{t("plat.complete")}</Link>}
    </div>
  );
};
